import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

export type ValidateResponse = {
    oauth_access_token?: string;
    oauth_user_id?: number | string;
};

export const validate = () => axios.get<ValidateResponse>(API_URLS.VALIDATE);
